import Footer from "./../../Footer";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import ShoppingCart from "../../cart/ShoppingCart/ShoppingCart";
import Modal from "./Modal";
import styles from "./CartWrapperModal.module.scss";
import EmptyCartScreen from "../../cart/ShoppingCart/EmptyCart";

interface ICartWrapperProps {
  isCartVisible: boolean;
  closeFunction: () => void;
}

const CartWrapperModal: React.FC<ICartWrapperProps> = (props) => {
  const context = useUnsafeCartContext();
  const {t} = useTranslation();

  if (!context) {
    return null;
  }

  const Header: React.FC = () => {
    const onLogoClicked = () => {
      if (isCart(context)) {
        context.setIsIntoCheckout(false);
      }
      props.closeFunction();
    };

    return (
      <div>
        <div className={styles.wrapper}>
          <div className={`${styles.logo} icon icon-connox-logo`} onClick={onLogoClicked} />
          <div className={styles.secureOrder}>
            <i className={"icon icon-lock icon-size--18"} />
            <span>&#160;{t("cart.secureConnection")}</span>
          </div>
        </div>
        {isCart(context) && !context.isIntoCheckout && (
          <div className={styles.backButton} onClick={props.closeFunction}>
            <i className={"icon icon-size--24 icon-left--blue"} />

            <span>{t("cart.continueShopping")}</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal fullScreen={true} isVisible={context.isCartVisible}>
      <div>
        <Header />
        {isCart(context) ? <ShoppingCart /> : <EmptyCartScreen />}
      </div>
      <Footer />
    </Modal>
  );
};

export default CartWrapperModal;
